import { render, staticRenderFns } from "./RegisterPrivacy.vue?vue&type=template&id=5a893251&scoped=true&"
import script from "./RegisterPrivacy.vue?vue&type=script&lang=ts&"
export * from "./RegisterPrivacy.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterPrivacy.vue?vue&type=style&index=0&id=5a893251&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a893251",
  null
  
)

export default component.exports